



























































import { Component, Vue } from "vue-property-decorator";
import { RenderEventBus } from "@/render-event-bus";
import { getPostPreviewInfo } from "@/services/posts/postsService";
import { PostPreviewInfo } from "@/services/posts/types";
import { Getter, Action } from "vuex-class";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

@Component
export default class PreviewModalSidebar extends Vue {
    @Getter("preview/getPreviewControlsStatus") previewControlStatus!: boolean;
    @Action("preview/setPreviewControlsStatus") setPreviewControlsStatus!: any;
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    post = {} as PostPreviewInfo;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    // lifecycle hooks
    public created(): void {
        RenderEventBus.$on("show-info", (postId: string) => {
            getPostPreviewInfo(postId).then(response => {
                this.post = response;
            });
        });

        RenderEventBus.$on("reset-info", () => {
            this.post = {} as PostPreviewInfo;
        });
    }

    toggleControls() {
        this.setPreviewControlsStatus();
    }

    channelForm(channelId: string) {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
            return {
                name: "updatechannel",
                params: { channelId: channelId }
            };
        } else {
            return {
                name: "editorupdatechannel",
                params: { channelId: channelId }
            };
        }
    }

    postForm(channelId: string, postId: string) {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
            return {
                name: "updatePost",
                params: { channelId: channelId, postId: postId }
            };
        } else {
            return {
                name: "editorUpdatePost",
                params: { channelId: channelId, postId: postId }
            };
        }
    }
}
